import "../phaser.min.js";
import Common from "../Includes/Common.js";
import ResultsSummary from "./ResultsSummary";
import Leaderboard from "./Leaderboard";
class GameOver extends Phaser.Scene {
    constructor() {
        super('GameOver');
        this.common = new Common();
        this.dataFetched = false;
    }

    preload() {

    }

    init(data) {
        this.player = data.player;
        this.questions = data.questions;
        this.leaderBoardEntries = [];

        if(!this.dataFetched) {
            this.submitScore();
            this.dataFetched = true;
        }
    }

    create() {
        this.winSFX = this.sound.add('win', {volume: this.common.bgMusicVolume});
        this.highscoreSFX = this.sound.add('highscore', {volume: this.common.blipVolume});

        this.winSFX.play();


        this.scene.stop('TriviaInfo');
        this.scene.launch('Car', {
            x: this.scale.width / 12 * 2,
            y: this.scale.height / 12 * 5.75,
            carKey: this.player.car.key,
            driving: true,
        });

        this.overlay = this.add.rectangle(0, 0, this.scale.width, this.scale.height, "#12202E")
                .setOrigin(0)
                .setAlpha(0.8)

        this.bg = this.add.image(0, 0, 'ui', 'dropdown-checkers')
                .setOrigin(0)
                .setScale(this.common.gameScale)

        this.nameText = this.add.text(this.scale.width / 2, this.scale.height / 8 * 2.5, 'Great Job, ' + this.player.name,
                { fontFamily: 'pixelify', fontSize: 96, color: "#333333"  })
                .setOrigin(0.5)

        let seconds = this.player.playTime / 100;

        this.scoreText = this.add.text(this.scale.width / 2, this.scale.height / 8 * 3, 'Score: ' + Math.floor(this.player.score) + ' Points',
                { fontFamily: 'pixelify', fontSize: 68, color: "#333333"  })
                .setOrigin(0.5)

        this.leaderBoardButton = this.add.sprite(this.scale.width / 2, this.scale.height / 12 * 8, 'ui', 'lb-normal')
                .setScale(this.common.gameScale)
        this.leaderBoardButton.setInteractive({cursor: 'pointer'})
        this.leaderBoardButton.on('pointerdown', () => {
            this.openLeaderBoard()
        })
        this.leaderBoardButton.on('pointerover', () => {
            this.tweens.add({
                targets: this.leaderBoardButton,
                scale: 4.2,
                duration: 100,
                ease: 'Power2',
            })
        })
        this.leaderBoardButton.on('pointerout', () => {
            this.tweens.add({
                targets: this.leaderBoardButton,
                scale: 4,
                duration: 100,
                ease: 'Power2',
            })
        })

        this.summaryButton = this.add.sprite(this.scale.width / 12 * 4, this.scale.height / 12 * 8, 'ui', 'results-normal')
                .setScale(this.common.gameScale)
        this.summaryButton.setInteractive({cursor: 'pointer'})
        this.summaryButton.on('pointerdown', () => {
            this.openResultsSummary()
        })
        this.summaryButton.on('pointerover', () => {
            this.tweens.add({
                targets: this.summaryButton,
                scale: 4.2,
                duration: 100,
                ease: 'Power2',
            })
        })
        this.summaryButton.on('pointerout', () => {
            this.tweens.add({
                targets: this.summaryButton,
                scale: 4,
                duration: 100,
                ease: 'Power2',
            })
        })

        this.replayButton = this.add.sprite(this.scale.width / 12 * 8, this.scale.height / 12 * 8, 'ui', 'replay-normal')
                .setScale(this.common.gameScale)
        this.replayButton.setInteractive({cursor: 'pointer'})
        this.replayButton.on('pointerdown', () => {
            this.resetGame();
        })
        this.replayButton.on('pointerover', () => {
            this.tweens.add({
                targets: this.replayButton,
                scale: 4.2,
                duration: 100,
                ease: 'Power2',
            })
        })
        this.replayButton.on('pointerout', () => {
            this.tweens.add({
                targets: this.replayButton,
                scale: 4,
                duration: 100,
                ease: 'Power2',
            })
        })

        this.shoutout = this.add.text(this.scale.width / 2, this.scale.height / 8 * 4, "Don't forget to checkout the Leaderboard!",
                { fontFamily: 'pixelify', fontSize: 56, color: "#333333"  })
                .setOrigin(0.5)
                .setResolution(4)
    }

    update() {

    }

    openResultsSummary() {
        if(!this.scene.get('ResultsSummary')) {
            this.scene.add('ResultsSummary', ResultsSummary);
        }
        this.scene.launch('ResultsSummary', {player: this.player, questions: this.questions});
        this.scene.moveAbove('GameOver', 'ResultsSummary');
    }

    openLeaderBoard() {
        if(!this.scene.get('Leaderboard')) {
            this.scene.add('Leaderboard', Leaderboard);
        }
        this.scene.launch('Leaderboard', {player: this.player, entries: this.leaderBoardEntries});
        this.scene.moveAbove('GameOver', 'Leaderboard');
    }

    resetGame = () => {
        window.location.reload();
    }

    async submitScore(){
        try {
            const leaderboardEntry = {
                entry: {
                    playerName: this.player.name,
                    score: this.player.score,
                    carSelection: this.player.car.key,
                    district: this.player.district,
                }
            }
            fetch(this.common.leaderboardEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json' // Set content type to JSON
                },
                body: JSON.stringify(leaderboardEntry) // Convert JavaScript object to a string
            })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        return response.json(); // Parse the response as JSON
                    })
                    .then(result => {
                        if(result.highscore) {
                            this.highscoreSFX.play();
                            this.add.text(this.scale.width / 2, this.scale.height / 8 * 3.5, 'NEW HIGHSCORE!', {
                                fontFamily: this.common.font,
                                fontSize: 48,
                                color: '#cba119'
                            }).setOrigin(0.5)
                        }
                        fetch(this.common.leaderboardEndpoint, {
                            method: 'GET',
                        }).then(response => {
                            if (!response.ok) {
                                throw new Error('Network response was not ok');
                            }
                            return response.json();
                        }).then(result => {
                            this.leaderBoardEntries = result.entries;
                        })
                    })
                    .catch(error => {
                        console.error('Error:', error);
                    });
        }catch (e) {
            console.error('Failed to submit score: ', e.message || 'Unknown error')
        }
    }
}

export default GameOver;